export default "__VITE_ASSET__0ebcb08a__"